import React, { useState } from "react";
import { Form, Col, Row, Button } from "react-bootstrap";

import ParentCompanyDropdown from "features/admin/sharedAdminComponents/ParentCompanyDropdown";

export default function ActivityAnalyticsForm(props) {
  const [selectedParentCompany, setSelectedParentCompany] = useState("");

  function clearForm() {
    setSelectedParentCompany("");
  }

  function resetOnClick() {
    clearForm();
    props.handleFormReset();
  }

  function handleFormSubmit(e) {
    e.preventDefault();
    submitForm();
  }

  function submitForm() {
    props.handleFormSubmit({
      selectedParentCompany: selectedParentCompany
        ? selectedParentCompany.value
        : null,
    });
  }

  return (
    <Form onSubmit={handleFormSubmit}>
      <Row className="justify-content-start">
        <Col md="auto" className="d-flex flex-column">
          <Form.Label>Parent Company</Form.Label>
          <Form.Control
            as={ParentCompanyDropdown}
            selectedParentCompany={selectedParentCompany}
            setSelectedParentCompany={setSelectedParentCompany}
          />
        </Col>
        <Col md="auto" className="d-flex flex-column justify-content-end">
          <Button className="inline-show-result-button" size="sm" type="submit">
            Search
          </Button>
        </Col>
        <Col md="auto" className="d-flex flex-column justify-content-end">
          <Button
            className="inline-show-result-button"
            size="sm"
            type="button"
            onClick={resetOnClick}
          >
            Reset
          </Button>
        </Col>
      </Row>
    </Form>
  );
}
